<template>
  <div class="">
    <b-button block  class="mt-4"
    @click="showModalNovo()" 
    variant="gradient-info"  
    >
        <b-avatar
        class="mb-1"
        :variant="`light-dark`"
        size="45"
        >
        <feather-icon
            size="21"
            icon="DollarSignIcon"
        />
        </b-avatar>
        <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
            
        </h2>
        <span>    PIX/BOLETO    </span>
        </div>
    </b-button>

     
      

    <b-modal v-model="show" :title="estabelecimento.name" hide-footer >
    <b-header class="text-center"><h4>PIX/BOLETO</h4></b-header>
    
      <form v-if="!isPix">

        <div class="form-group">

          <div class="demo-inline-spacing ">
            <b-form-radio
              v-model="Selected"
              name="CPF"
              value="CPF"
         
            >
              CPF
            </b-form-radio>
            <b-form-radio
              v-model="Selected"
              name="CNPJ"
              value="CNPJ"
            >
              CNPJ
            </b-form-radio>
          </div>
  
          <b-form-input
          id="input-valid"
          :state="documentoValido"
          v-mask="dynamicMask"
            type="text"
            class="form-control mt-1"
            v-model="ordem.documento"
            :disabled="isDisabled"
       
          />
          <b-form-valid-feedback>
          Documento válido
        </b-form-valid-feedback>
        </div>


      <div v-if="true">
        <b-row>
          <b-col cols="12">
              <div class="form-group">
                <label>Nome:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.name"
            
                />
              </div>
          </b-col>  
        </b-row>

        <!-- Endereço do cliente -->

        <b-row>
          <b-col cols="4">
              <div class="form-group">
                <label>Cep:  </label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  v-model="ordem.zipCode"
            
                />
              </div>
          </b-col>  
          <b-col cols="6">
              <div class="form-group">
                <label>Endereço:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.street"
            
                />
              </div>
          </b-col>
          <b-col cols="2">
              <div class="form-group">
                <label>Numero:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.number"
            
                />
              </div>
          </b-col>
 
        </b-row>

        <b-row>
          
          <b-col cols="5">
              <div class="form-group">
                <label>Bairro:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.neighborhood"
            
                />
              </div>
          </b-col>  
          <b-col cols="5">
              <div class="form-group">
                <label>Cidade:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.city"
            
                />
              </div>
          </b-col> 
          <b-col cols="2">
              <div class="form-group">
                <label>Estado:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.uf"
            
                />
              </div>
          </b-col>  
 
        </b-row>

        <b-row>
          <b-col cols="6">
            <div class="form-group">
              <label>Valor boleto:  </label>
              <input
            
                type="text"
                class="form-control"
                v-model="ordem.valor"
          
              />
            </div>
          </b-col >
          <b-col cols="6">
            <div class="form-group">
              <label>Vencimento:  </label>
              <input
              
                type="date"
                class="form-control"
                v-model="ordem.vencimento"
          
              />
            </div>
          </b-col>
        </b-row> 

<!-- multa -->
        <b-row>
          <b-col cols="2">
             <div class="form-group">
             
             <b-card-text class="mb-0">
                Multa
              </b-card-text>
              <b-form-checkbox
              v-model="multa"
                :checked="multa"
                class="custom-control-primary"
                name="check-button"
                switch
              />
            
            </div>
          </b-col >
          <b-col cols="5">

              <div v-if="multa" class="form-group">
                <label>Porcentagem:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.porcentagemMulta"
            
                />
              </div>

          </b-col>
          <b-col cols="5">
              <div v-if="multa" class="form-group">
              <label>Apartir:  </label>
              <input
              
                type="date"
                class="form-control"
                v-model="ordem.dataMulta"
          
              />
            </div>
         

          </b-col>
        </b-row> 
        <!-- juros -->
        <b-row>
          <b-col cols="2">
             <div class="form-group">
             
             <b-card-text class="mb-0">
                Juros
              </b-card-text>
              <b-form-checkbox
              v-model="juros"
                :checked="juros"
                class="custom-control-primary"
                name="check-button"
                switch
              />
            
            </div>
          </b-col >
          <b-col cols="5">

              <div v-if="juros" class="form-group">
                <label>Juros mês:  </label>
                <input
        
                  type="text"
                  class="form-control"
                  v-model="ordem.porcentagemJuros"
            
                />
              </div>

          </b-col>
          <b-col cols="5">
           
         

          </b-col>
        </b-row> 
       </div> 
        <div class="text-center">

          <b-button variant="gradient-dark "
           v-if="!spiner"
            
             @click="Salvar()"
            >
              Gerar
          </b-button>
       
          <b-button
          v-if="spiner"
              variant="gradient-dark"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Gerando
          </b-button>
          
        </div>
     
      </form>


    </b-modal>


    <b-modal title="PIX/BOLETO" v-model="isPix" size="lg" hide-footer>
      <div class="boleto ">
            <!-- <input class="noprint" type="button" value="IMPRIMIR" onClick="window.print();return false" /> -->
            <div  class="card  " style="border-radius: 13px; padding: 5px;">
                <div class="card-body">
                    <div class="row">
                        <div class="col">  <h4 class="text-primary">Olá {{resposta.customer.name}}</h4>
                            <p class=" text-info">PAGWISE permite pagar seu boleto com pix!</p>
                        </div>
                    </div>

                    <div class="row ">
                        <div class="col col-4">
                            <div class="row cardvalor">
                                <div class="col p-1 ">
                                    <h5 class="text-left text-white " >Valor:</h5>
                                    <h6 class="text-white" >R$ {{resposta.valor}}</h6>
                                </div>
                            </div>
                            <div class="row cardvencimento mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-white">Vencimento:</h5>
                                    <h6 class="text-white" >{{resposta.vencimento}}</h6>
                                </div>
                            </div>
                            <div class="row carddescricao mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-info">Descrição:</h5>
                                    <p >{{resposta.descricao}}</p>
                                </div>
                            </div>

                            <div class="row carddescricao mt-1">
                                <div class="col p-1">
                                    <h5 class="text-left text-info">Após o vencimento:</h5>
                                    <p >Juros: 0% </p>
                                    <p >Multa: 0%</p>
                                </div>
                            </div>

                        </div>
                        <div class="col col-8">
                            <div class="row">
                                <div class="col">
                                     <qrcode   :value="resposta.textoImagemQRcode" :options="options"></qrcode>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div class="row mt-1">
                        <div class="col">  <p class="text-info">PIX copia e cola: </p> </div>
                    </div>
                
                    <div class="row ">

                        <div class="input-group">
                            <input id="pixCopiaCola" :value="resposta.textoImagemQRcode" type="text" class="form-control"  >
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-info btn-sm"
                                @click="copyToClipboard()">Copiar</button>
                            </div>
                        </div>
                    
                    </div>

                    <div class="row">
                        <table cellSpacing=0 cellPadding=0 border=0 class="">

                            <tr>
                                <td style='width: 0.9cm'></td>
                                <td style='width: 1cm'></td>
                                <td style='width: 1.9cm'></td>
                                <td style='width: 0.5cm'></td>
                                <td style='width: 1.3cm'></td>
                                <td style='width: 0.8cm'></td>
                                <td style='width: 1cm'></td>
                                <td style='width: 1.9cm'></td>
                                <td style='width: 1.9cm'></td>
                                <td style='width: 3.8cm'></td>
                                <td style='width: 3.8cm'></td>

                            </tr>
                        
                            <tr>
                                <td colspan=11 height=20 valign=top>&nbsp</td>
                            </tr>
                            <tr>
                                <td colspan=11 class=BoletoPontilhado>&nbsp;</td>
                            </tr>
                            <tr>
                                <td colspan=4 class=BoletoLogo>
                                    <img src="data:image/jpeg;base64,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"
                                        alt="">
                                </td>
                                <td colspan=2 class=BoletoCodigoBanco>001-9</td>
                                <td v-mask="dynamicMask" colspan=6 class=BoletoLinhaDigitavel>{{resposta.linhaDigitavel}}</td>
                            </tr>
                            <tr>
                                <td colspan=10 class=BoletoTituloEsquerdo>Local de Pagamento</td>
                                <td class=BoletoTituloDireito>Vencimento</td>
                            </tr>
                            <tr>
                                <td colspan=10 class=BoletoValorEsquerdo style='text-align: left; padding-left : 0.1cm'>Pagável em qualquer agência bancária</td>
                                <td class=BoletoValorDireito>{{resposta.vencimento}}</td>
                            </tr>
                            <tr>
                                <td colspan=8 class=BoletoTituloEsquerdo>Beneficiário</td>
                                <td colspan=2 class=BoletoTituloEsquerdo>CPF/CNPJ do Beneficiário</td>
                                <td class=BoletoTituloDireito>Agencia/Codigo do Beneficiário</td>
                            </tr>
                            <tr>
                                <td colspan=8 class=BoletoValorEsquerdo style='text-align: left; padding-left : 0.1cm'>PagWise</td>
                                <td colspan=2 class=BoletoValorEsquerdo>{{resposta.documento}}</td>
                                <td class=BoletoValorDireito>4336</td>
                            </tr>
                            <tr>
                                <td colspan=3 class=BoletoTituloEsquerdo>Data do Documento</td>
                                <td colspan=4 class=BoletoTituloEsquerdo>Nr. do Documento</td>
                                <td class=BoletoTituloEsquerdo>Espécie Doc</td>
                                <td class=BoletoTituloEsquerdo>Aceite</td>
                                <td class=BoletoTituloEsquerdo>Data do Processamento</td>
                                <td class=BoletoTituloDireito>Nosso Número</td>
                            </tr>
                            <tr>
                                <td colspan=3 class=BoletoValorEsquerdo></td>
                                <td colspan=4 class=BoletoValorEsquerdo></td>
                                <td class=BoletoValorEsquerdo>RC</td>
                                <td class=BoletoValorEsquerdo>N</td>
                                <td class=BoletoValorEsquerdo></td>
                                <td class=BoletoValorDireito></td>
                            </tr>
                            <tr>
                                <td colspan=3 class=BoletoTituloEsquerdo>Uso do Banco</td>
                                <td colspan=2 class=BoletoTituloEsquerdo>Carteira</td>
                                <td colspan=2 class=BoletoTituloEsquerdo>Moeda</td>
                                <td colspan=2 class=BoletoTituloEsquerdo>Quantidade</td>
                                <td class=BoletoTituloEsquerdo>(x) Valor</td>
                                <td class=BoletoTituloDireito>(=) Valor do Documento</td>
                            </tr>
                            <tr>
                                <td colspan=3 class=BoletoValorEsquerdo>&nbsp;</td>
                                <td colspan=2 class=BoletoValorEsquerdo>17</td>
                                <td colspan=2 class=BoletoValorEsquerdo>R$</td>
                                <td colspan=2 class=BoletoValorEsquerdo>&nbsp;</td>
                                <td class=BoletoValorEsquerdo> </td>
                                <td class=BoletoValorDireito>R$ {{resposta.valor}}</td>
                            </tr>
                            <tr>
                                <td colspan=10 class=BoletoTituloEsquerdo>Instruções</td>
                                <td class=BoletoTituloDireito> (-) Desconto</td>
                            </tr>
                            <tr>
                                <td colspan=10 rowspan=9 class=BoletoValorEsquerdo
                                    style='text-align: left; vertical-align:top; padding-left : 0.1cm'>
                                    Pagável em qualquer agência bancária
                                </td>
                
                                <td style='height: 20px;' class=BoletoValorDireito>&nbsp;</td>
                                
                            </tr>
                            <tr>
                                <td class=BoletoTituloDireito>(-) Outras Deduções/Abatimento</td>
                            </tr>
                            <tr>
                                <td style='height: 20px;' class=BoletoValorDireito>&nbsp;</td>
                            </tr>
                            <tr>
                                <td class=BoletoTituloDireito>(+) Mora/Multa/Juros</td>
                            </tr>
                            <tr>
                                <td style='height: 20px;' class=BoletoValorDireito>&nbsp; </td>
                            </tr>
                            <tr>
                                <td class=BoletoTituloDireito>(+) Outros Acréscimos</td>
                            </tr>
                            <tr>
                                <td style='height: 20px;' class=BoletoValorDireito>&nbsp; </td>
                            </tr>
                            <tr>
                                <td class=BoletoTituloDireito>(=) Valor Cobrado</td>
                            </tr>
                            <tr>
                                <td style='height: 20px;' class=BoletoValorDireito>&nbsp; </td>
                            </tr>
                            <tr>
                                <td rowspan=3 Class=BoletoTituloSacado>Pagador:</td>
                                <td colspan=1 Class=BoletoValorSacado> </td>
                                <td colspan=7 Class=BoletoValorSacado> Osmar Junior Chimello - CPF 04930489954 </td>
                            </tr>
                            <tr>
                                <td colspan=10 Class=BoletoValorSacado></td>
                            </tr>
                            <tr>
                                <td style='height: 40px;' colspan=10 Class=BoletoValorSacado>&nbsp;&nbsp;&nbsp;</td>
                            </tr>
                            <tr>
                                <td colspan=2 Class=BoletoTituloSacador>Sacador / Avalista:</td>
                                <td   colspan=9 Class=BoletoValorSacador></td>
                            </tr>
                            <tr>
                                <td colspan=11 class=BoletoTituloDireito style='text-align: right; padding-right: 0.1cm'>Ficha de
                                    Compensação - Autenticação Mecanica</td>
                            </tr>
                            <tr>
                                <td colspan=11   class="text-left" valign=top>
                                  
                                  <VueBarcode width="2" height="50" :displayValue="false"  v-bind:value="resposta.codigoBarraNumerico">
                                  
                                  </VueBarcode>
                                 
                                   
                                </td>
                            </tr>
                            <tr>
                                <td colspan=11 class=BoletoPontilhado>&nbsp;</td>
                            </tr>
                        </table>
                    </div>

                </div>
            </div>
      </div>
    </b-modal>
   </div>
</template>
<script>
import {BFormCheckbox, BFormInvalidFeedback, BFormValidFeedback, BFormRadio,BFormInput,BInputGroupPrepend,BInputGroup, BButton, BSpinner,BCard, BAvatar, BCardText, BLink,BRow, BCol,BFormGroup } from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qrcode from 'tui-vue-qrcode'
import axios from '@/libs/axios'
import { io } from "socket.io-client";
const socket = io('https://api.pagwise.com/orders');

export default {
    components: {
    BButton,
    BAvatar,
    BCol,
    BCard,
    BRow,
    BSpinner,
    BLink,
    BCardText,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormRadio,BFormInvalidFeedback, BFormValidFeedback,qrcode,BFormCheckbox
  },
 
    data() {
        return {
          multa:false,
          juros:false,
          isPix:false,
          options:{size:300},

            documentoValido: false,
            Selected:"",
            dynamicMask:'###.###.###-##',
            status: "",
            password: "",
            show: false,
            isDisabled: true,
            spiner:false,
            consultaCep:false,
      
            ordem: {
                name: null,
                documento:true,
                valor:null,
                vencimento: null,
                street: null,
                neighborhood: null,
                city: null,
                uf: null,
                zipCode: null,
                number:null,
                dataMulta:null,
                porcentagemMulta:null,
                porcentagemJuros:null
                
            },
            resposta:{customer:{}},
        }
    },

    created() {},

  watch:{

   async 'ordem.zipCode'(str) {
      str = str.replace("-", "").replace(".", "")

      if(str.length < 8 ){

          this.consultaCep = false
      }
      
      if(str.length === 8 && !this.consultaCep){
      const  b = await this.buscarCep(str)
           this.ordem= {
                          name: this.ordem.name,
                          documento: this.ordem.documento,
                          street: b.logradouro,
                          neighborhood: b.bairro,
                          city: b.localidade,
                          uf: b.uf,
                          zipCode: b.cep
      
                        }
         
      }
    },

    'ordem.documento'(str) {
     
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      // console.log(str.length)
      if(this.Selected === "CPF"){
      
      this.documentoValido = this.validateCPF(str)
      console.log(this.validateCPF(str))

      if(this.documentoValido){
          this.buscar_customer(str)
      }
      }
      if(this.Selected === "CNPJ"){
      // console.log('cnpj')
      this.documentoValido =this.validateCNPJ(str)
      if(this.documentoValido){
          this.buscar_customer(str)
      }
        
      }

    },

    Selected(str) {
     if(str === "CPF"){
      this.isDisabled = false
      this.dynamicMask = '###.###.###-##'
     }
      if(str === "CNPJ"){
        this.isDisabled = false
        this.dynamicMask =  '##.###.###.####-##'

      }

    },
    
    
  },
  
  computed: {
    estabelecimento() {
        return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
  },

  methods: {

    respostaPixBoleto(data){
            
                // this.respostaPix = data
                if(data.orderId === this.resposta.id){
                    this.$alert(
                    "Pagamento realizado com sucesso",
                    "Parabéns",
                    "success"
                    ).then(
                     this.show = false,
                        this.isPix = false,
                        this.isDisabled = true,
                    this.resposta = {customer:{}},
                    this.close_connection()
                    );
                }
                
 
    },
    websocket_conection(orderId){
            socket.on(orderId, this.respostaPixBoleto); 
    },
     close_connection(){
            // socket.disconnect();

    },
    

    async  Salvar(){
    this.spiner = true
    this.isDisabled = true

      let str= this.ordem.documento;
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      str = str.replace("-", "").replace(".", "")
      

      let dados = {
                name: this.ordem.name,
                documento: str,
                valor: this.ordem.valor,
                vencimento: this.ordem.vencimento,
                apiKey: this.estabelecimento.apiKey,
                rua: this.ordem.street,
                neighborhood: this.ordem.neighborhood,
                city: this.ordem.city,
                uf: this.ordem.uf,
                zipCode:  this.ordem.zipCode.replace("-", "").replace(".", ""),
                dataMulta: this.ordem.dataMulta,
                porcentagemMulta: this.ordem.porcentagemMulta,
                porcentagemJuros: this.ordem.porcentagemJuros,
                id: this.estabelecimento.id

      }

      // console.log(dados)
      await this.$store
        .dispatch("estabelecimentos/gerarBoleto", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          
          });
          this.BuscarOrder(dados)

          console.log(data.data.data)
          this.websocket_conection(data.data.data.id)
          this.resposta = data.data.data
          this.isPix =  true
          this.show = false
          this.spiner = false
         
        })
        .catch((error) => {

           this.spiner = false
          this.isDisabled = false

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
         
        });
      
     
    },
    async BuscarOrder(dados){
      
        await this.$store.dispatch("estabelecimentos/getListOrder", dados)
        .then(() => { })
        .catch((error) => {
        
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });

    },

    async buscar_customer(str){

       await this.$store
        .dispatch("estabelecimentos/get_customer", str)
        .then((data ) => {
          this.ordem = {
                name: data.data.name,
                documento: this.ordem.documento,
                street: data.data.street,
                neighborhood: data.data.neighborhood,
                city: data.data.city,
                uf: data.data.uf,
                zipCode: data.data.zipCode,
        
          }
          this.consultaCep = true
      
        })
        .catch((error) => {
          this.consultaCep = false
        return error
        });

    },
    buscarCep(cep){
      return new Promise((resolve, reject) => {
            
              return axios.get("https://viacep.com.br/ws/"+cep+"/json/"
                  )
                .then(({ data }) => {
                     this.consultaCep = true
                      resolve(data);
                  })
                  .catch(error => {
                     this.consultaCep = false
                      reject(error)
                  });
          });


    },

    formatPrice(value) {
      const val = Number(value.replace(",", "."));
      if (!val) return '0,00';
      const valueString = val.toFixed(2).replace(".", ",");
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    showModalNovo() {
            this.isPix = false
            // this.isDisabled = false
               this.ordem= {
                name: null,
                documento:true,
                valor: null,
                segundos: 3600
               }
      this.show = true;
    },
   
    validateCPF(cpf) {
      var numeros, digitos, soma, i, resultado, digitos_iguais;
      digitos_iguais = 1;
      if (cpf.length < 11) return false;
      for (i = 0; i < cpf.length - 1; i++)
        if (cpf.charAt(i) != cpf.charAt(i + 1)) {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(0)) return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado != digitos.charAt(1)) return false;
        return true;
      } else return false;
    },

    validateCNPJ(value) {
    const blackList = [
      '00000000000000',
      '11111111111111',
      '22222222222222',
      '33333333333333',
      '44444444444444',
      '55555555555555',
      '66666666666666',
      '77777777777777',
      '88888888888888',
      '99999999999999',
  ];
      const cnpj = value.replace(/[^\d]+/g, '');

      if (cnpj == '') return false;

      if (cnpj.length != 14) return false;

      // Elimina CNPJs inválidos conhecidos
      if (blackList.includes(cnpj)) {
          return false;
      }

      // Valida DVs
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
          soma += Number(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != Number(digitos.charAt(0))) {
          return false;
      }

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
          soma += Number(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != Number(digitos.charAt(1))) {
          return false;
      }
      return true;
    }

  },
};
</script>
    
<style scoped>
     
        .boleto {
            text-align: center;
            max-width: 100%; 
            margin-left: auto;
            margin-right: auto; 
        }
        td.BoletoCodigoBanco {
            font-size: 6mm;
            font-family: arial, verdana;
            font-weight: bold;
            FONT-STYLE: italic;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            padding-bottom: 1mm
        }

        td.BoletoLogo {
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            text-align: center;
            height: 10mm;

            /*
      max-height:10mm;
      width: auto;
      height: auto;
      */

        }

        td.BoletoLinhaDigitavel {
            font-size: 4 mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            padding-bottom: 1mm;
        }

        td.BoletoTituloEsquerdo {
            font-size: 0.2cm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            border-right: 0.15mm solid #000000;
            text-align: left
        }

        td.BoletoTituloDireito {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            text-align: left
        }

        td.BoletoValorEsquerdo {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: center;
            border-right: 0.15mm solid #000000;
            font-weight: bold;
            border-bottom: 0.15mm solid #000000;
            padding-top: 0.5mm
        }

        td.BoletoValorDireito {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: right;
            padding-right: 3mm;
            padding-top: 0.8mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
        }

        td.BoletoTituloSacado {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: top;
            padding-top: 0.15mm;
            text-align: left
        }

        td.BoletoValorSacado {
            font-size: 3mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: left
        }

        td.BoletoTituloSacador {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: bottom;
            padding-bottom: 0.8mm;
            border-bottom: 0.15mm solid #000000
        }

        td.BoletoValorSacador {
            font-size: 3mm;
            font-family: arial, verdana;
            vertical-align: bottom;
            padding-bottom: 0.15mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
            text-align: left
        }

        td.BoletoPontilhado {
            border-top: 0.3mm dashed #000000;
            font-size: 1mm
        }

        ul.BoletoInstrucoes {
            font-size: 3mm;
            font-family: verdana, arial
        }

        @media print {
            .noprint {
                display: none;
            }

            body {
                background: #fff;
            }
        }

        .cardvalor {
            background-color: #1155d4;
            border-radius: 13px;
            color: #fff;
        }
        .cardvencimento {
            background-color: #1193d4;
            border-radius: 13px;
            color: #fff;    
        }
        .carddescricao {
            background-color: #eef4f6;
            border-radius: 13px;
            color: rgb(56, 52, 52);
        }
        body {
          background-color: #f6f6f6;
        }
    </style>